// ─── 🕘 Lo storico dei dati, nella scheda del socio (B1 · 3A, 29/09/2026) ────
//
// Dal mockup «I miei dati», approvato: nome, cognome e numero, prima → dopo,
// con la data e chi l'ha fatto — il bot «Padel Village su Telegram» per conto del socio, o
// chi della Segreteria. Anche le modifiche di prima: il gestionale le registra
// da sempre, e adesso si vedono.

import { ETICHETTE_CAMPI_DELLO_STORICO, type RigaStoricoDati } from '@pmo/shared';
import { usaStoricoDeiDati } from '../../features/soci/dati.js';
import { Guasto } from '../../components/pezzi.js';

const quando = (iso: string): string =>
  new Date(iso).toLocaleString('it-IT', {
    timeZone: 'Europe/Rome',
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });

function chi(r: RigaStoricoDati): string {
  if (r.by === 'assistente') return 'Padel Village su Telegram';
  if (r.by === 'segreteria') return r.actorName ? `${r.actorName} (Segreteria)` : 'Segreteria';
  return 'import';
}

export function StoricoDeiDati({ id }: { id: string }): React.JSX.Element {
  const s = usaStoricoDeiDati(id);
  return (
    <section className="riquadro storico-dati">
      <h3>🕘 Storico dei dati</h3>
      {s.error ? (
        <Guasto errore={s.error} />
      ) : !s.data ? (
        <p className="tenue piccolo">Lo leggo…</p>
      ) : s.data.length === 0 ? (
        <p className="tenue piccolo">
          Nome, cognome e numero sono quelli di quando la scheda è nata: nessuno li ha cambiati.
        </p>
      ) : (
        <div className="tabella-scorre">
          <table>
            <thead>
              <tr>
                <th>Quando</th>
                <th>Cosa</th>
                <th>Prima → dopo</th>
                <th>Chi</th>
              </tr>
            </thead>
            <tbody>
              {s.data.map((r, i) => (
                <tr key={`${r.at}-${r.field}-${i}`}>
                  <td className="quando">{quando(r.at)}</td>
                  <td>{ETICHETTE_CAMPI_DELLO_STORICO[r.field]}</td>
                  <td>
                    {r.before ?? <span className="tenue">(vuoto)</span>} →{' '}
                    {r.after ?? <span className="tenue">(vuoto)</span>}
                  </td>
                  <td>{chi(r)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
